// extracted by mini-css-extract-plugin
module.exports = {"anchor":"zifpga","hi":"_37G_zy","hiHover":"wqEI46","md":"G5D3O6","mdHover":"oj0q9U","brand":"vjDVrf","brandHover":"kjPPpa"};